import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import RefreshAds from './RefreshAds';
import safelyEvalAdScript from './safelyEvalAdScript';
import areAdsBypassed from './areAdsBypassed';
import isDevelopment from './isDevelopment';
export default function InsertDiscussionPageHeaderAd() {
  const AdCode = app.data['nagusi-ext-ads.ad-code.discussion_header'];
  const Script = app.data['nagusi-ext-ads.ad-code.discussion_header.js'];
  const dev = isDevelopment();
  const Html = dev ? m("p", null, "Anuncio") : m.trust(AdCode);
  override(DiscussionPage.prototype, 'view', function (originalFunc) {
    const vnode = originalFunc();
    if (areAdsBypassed()) return vnode;
    const adVnode = m("div", {
      className: "nagusi-ad nagusi-ad-discussion-header",
      align: "center"
    }, Html);
    if (vnode && vnode.children) {
      if (Array.isArray(vnode.children)) {
        vnode.children.unshift(adVnode);
      } else {
        vnode.children = [adVnode, vnode.children];
      }
    }
    return vnode;
  });
  extend(DiscussionPage.prototype, ['oncreate', 'onupdate'], function (returned) {
    if (areAdsBypassed() || dev) return;
    RefreshAds();
    safelyEvalAdScript('discussion page header', Script);
  });
}